import { CalendarDate } from "@internationalized/date";

export function parseCalendarDateFromString(
	str: string | null
): CalendarDate | null {
	if (!str) {
		return null;
	}
	const [y, m, d] = str.split("-").map(Number);
	if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) {
		return null;
	}
	return new CalendarDate(y, m, d);
}
